import { render, staticRenderFns } from "./ManageMenuOrderView.vue?vue&type=template&id=9f611f1e&"
import script from "./ManageMenuOrderView.vue?vue&type=script&lang=js&"
export * from "./ManageMenuOrderView.vue?vue&type=script&lang=js&"
import style0 from "./ManageMenuOrderView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCol,VProgressCircular,VRow,VSnackbar})
